export default __webpack_public_path__ + "static/media/correos.ab0b9f86.svg";